import { Box, IconButton, ExpandLessIcon, ExpandMoreIcon, Typography, RouteOutlinedIcon } from 'src/components';
import { useState, useEffect } from 'react';

export default function TripDesktopModal({children, isExpanded, setIsExpanded, isDesktopWideView}) {
  const [showChildren, setShowChildren] = useState(isExpanded);

  useEffect(() => {
    const timeout = setTimeout(() => setShowChildren(isExpanded), 100);
    return () => clearTimeout(timeout);
  }, [isExpanded]);

  return (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            p: isExpanded ? 0 : 1,
            paddingLeft: isExpanded ? 0 : 2,
            m: 3,
            background: 'white',
            width: isExpanded ? (isDesktopWideView ? '430px' : '360px') : '200px',
            height: isExpanded ? 'calc(100vh - 120px)' : '50px',
            overflow: 'hidden',
            borderRadius: 8,
            boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
            willChange: 'height',
            transition: 'all 0.4s ease-in-out',
            pointerEvents: 'auto',
            position: 'relative',
        }}>

        <IconButton 
          onClick={() => setIsExpanded(!isExpanded)} 
          size="small" 
          disableRipple
          sx={{
            position: 'absolute',
            top: isExpanded ? '20px' : '10px',
            right: '8px', 
            zIndex: 1000
          }}>

            {isExpanded ? <ExpandLessIcon fontSize="small" />
            : <ExpandMoreIcon fontSize="small" />}

        </IconButton>
        
        {!isExpanded && (
          <Box sx={{
              display: 'flex', 
              flexDirection: 'row', 
              position: 'relative',
              alignItems: 'center'}}>

              <RouteOutlinedIcon fontSize="small" />

              <Typography variant="h6" sx={{ml: 1}}>Track Your Trips</Typography>

          </Box>
        )}

        {isExpanded && (
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                opacity: showChildren ? 1 : 0,
                transition: 'opacity 0.4s ease-in-out',
                pointerEvents: showChildren ? 'auto' : 'none',
                overflow: 'hidden',
                height: '100%'
              }}>

                {showChildren ? children : null}

            </Box>
        )}

    </Box>
  );
}
